import { render, staticRenderFns } from "./history-intercom.vue?vue&type=template&id=8df12674&scoped=true"
import script from "./history-intercom.vue?vue&type=script&lang=js"
export * from "./history-intercom.vue?vue&type=script&lang=js"
import style0 from "./history-intercom.vue?vue&type=style&index=0&id=8df12674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df12674",
  null
  
)

export default component.exports